const value = {
    title: 'Page not found',
    message: '',
    button: 'To projects',
  };

export default value;
